<template>
  <div>
    <Head title="Ubah Permohonan Beasiswa" />
    <h1 class="mb-8 text-2xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/scholar-applications">Permohonan Beasiswa</Link>
      <span class="font-medium text-indigo-400">/</span>
      {{ application.periode }}
    </h1>
    <div class="w-full bg-white rounded-md shadow">
      <form @submit.prevent="update">
        <div class="flex flex-wrap p-8 -mb-8 -mr-6">
          <div class="w-full pb-8 pr-6 lg:w-1/3">
            <label for="scholarship_id" class="form-label">Periode Beasiswa</label>
            <v-select
              v-model="form.scholarship_id" :options="scholarships" :reduce="scholarship => scholarship.id"
              label="periode" placeholder="Pilih Periode Beasiswa"
            />
            <div v-if="form.errors.scholarship_id" class="form-error">{{ form.errors.scholarship_id }}</div>
          </div>
          <text-input
            v-model.number="form.penghasilan_orangtua" type="number" :error="form.errors.penghasilan_orangtua"
            class="w-full pb-8 pr-6 lg:w-1/3" label="Penghasilan Orang Tua"
          />
          <text-input
            v-model.number="form.jumlah_tanggungan_orangtua" type="number"
            :error="form.errors.jumlah_tanggungan_orangtua" class="w-full pb-8 pr-6 lg:w-1/3"
            label="Jumlah Tanggungan Orang Tua"
          />
          <select-input
            v-model="form.semester" :error="form.errors.semester" class="w-full pb-8 pr-6 lg:w-1/3"
            label="Semester"
          >
            <option value="1">Semester 1</option>
            <option value="2">Semester 2</option>
            <option value="3">Semester 3</option>
            <option value="4">Semester 4</option>
            <option value="5">Semester 5</option>
            <option value="6">Semester 6</option>
            <option value="7">Semester 7</option>
            <option value="8">Semester 8</option>
          </select-input>
          <text-input
            v-model.number="form.nilai_ukt" type="number" :error="form.errors.nilai_ukt"
            class="w-full pb-8 pr-6 lg:w-1/3" label="Nilai UKT (Uang Kuliah Tunggal)"
          />

          <div class="w-full pb-8 pr-6 lg:w-1/3">
            <label for="is_prasejahtera" class="form-label">Kondisi Ekonomi</label>
            <input id="is_prasejahtera" v-model="form.is_prasejahtera" type="checkbox" class="mr-2" />
            <label for="is_prasejahtera" class="items-center cursor-pointer">
              Tidak Mampu (Pra-Sejahtera)
            </label>
          </div>

          <div class="w-full pb-8 pr-6 lg:w-1/3">
            <label for="scholarship_id" class="form-label">Prestasi Akademik/ Non Akademik</label>
            <div class="w-full pb-8 pr-6 ">
              <div class="w-full pb-4 pr-6 ">
                <input id="is_berprestasi_internasional" v-model="form.is_berprestasi_internasional" type="checkbox" class="mr-2" />
                <label for="is_berprestasi_internasional" class="items-center cursor-pointer">
                  Internasional
                </label>
              </div>
              <div class="w-full pb-4 pr-6 ">
                <input id="is_berprestasi_nasional" v-model="form.is_berprestasi_nasional" type="checkbox" class="mr-2" />
                <label for="is_berprestasi_nasional" class="items-center cursor-pointer">
                  Nasional
                </label>
              </div>
              <div class="w-full pb-4 pr-6 ">
                <input id="is_berprestasi_lokal" v-model="form.is_berprestasi_lokal" type="checkbox" class="mr-2" />
                <label for="is_berprestasi_lokal" class="items-center cursor-pointer">
                  Provinsi
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="flex items-center px-8 py-4 border-t border-gray-100 bg-gray-50">
          <Link class="btn-red" :href="`/scholar-applications`">
            <font-awesome-icon class="mr-2" icon="fas fa-arrow-left" />Kembali
          </Link>
          <loading-button :loading="form.processing" class="ml-auto btn-green" type="submit">
            <font-awesome-icon class="mr-2" icon="fas fa-key" />Simpan
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '../../Shared/SelectInput.vue'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
    SelectInput,
  },
  layout: Layout,
  props: {
    application: Object,
    scholarships: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        scholarship_id: this.application.scholarship_id,
        penghasilan_orangtua: this.application.penghasilan_orangtua,
        jumlah_tanggungan_orangtua: this.application.jumlah_tanggungan_orangtua,
        semester: this.application.semester,
        nilai_ukt: this.application.nilai_ukt,
        is_berprestasi: this.application.is_berprestasi,
        is_prasejahtera : this.application.is_prasejahtera,
        is_berprestasi_internasional : this.application.is_berprestasi_internasional,
        is_berprestasi_nasional : this.application.is_berprestasi_nasional,
        is_berprestasi_lokal : this.application.is_berprestasi_lokal,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/scholar-applications/${this.application.id}`)
    },
  },
}
</script>
<style scoped>.vuejs3-datepicker__value {
  width: 100%;
  border-color: rgba(226, 232, 240, var(--tw-border-opacity));
}</style>
